import axios from 'axios';
import { CartData } from '../types/cart.types';
import { BACKEND_URL, REACT_APP_ENV } from "./apiConfig";
import { log } from "../utils/logger";
import { getAuthTokenOptional, getAuthToken, getAuthHeader } from "./authUtils";
interface CartItem {
    category: string
    id: number,
    amount: number,
    date: string,
    time: string
}
interface CartDeleteItem {
    category: string
    id: number,
    date: string,
    time: string
}


// Create cart
/*
returns:

[
  {
    "id": 15,
    "created_by": null,
    "edited": null,
    "person_id": 1014,
    "subscriber_id": 1010,
    "cart_active": true,
    "event_date": null,
    "delivery_time": null,
    "items": {
      "1. 8. 2025": [],
      "2. 8. 2025": []
    },
    "time": {
      "from": "1/8/2025",
      "to": "2/8/2025"
    },
    "totals": null
  }
]
*/
export const createCart = async (id: number, start: string, end: string, adress: string, dates: string[]) => {
  const token = getAuthTokenOptional();

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts`,
    {
      subscriber_id: id,
      event_dates: {
        start: start,
        end: end
      },
      selected_dates: dates,
      adress: adress
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data;
};
// Delete cart
export const deleteCart = async () => {
  const token = getAuthToken();
  const response = await axios.get(
    `${BACKEND_URL}/eshop/carts/deactivate`,
    {
      headers: getAuthHeader(token)
    }
  );
  return response.data;
};
// Get cart 
/*
returns:

{
  "id": 15,
  "created_by": null,
  "edited": null,
  "person_id": 1014,
  "subscriber_id": 1010,
  "cart_active": true,
  "event_date": null,
  "delivery_time": null,
  "items": {
    "1. 8. 2025": [],
    "2. 8. 2025": []
  },
  "time": {
    "from": "1/8/2025",
    "to": "2/8/2025"
  },
  "totals": null
}
*/
export const getCart = async () => {
  const token = getAuthTokenOptional();
  const response = await axios.get<CartData | null>(`${BACKEND_URL}/eshop/carts`,{
      headers:{
          Authorization: `Bearer ${token}`
      }
  });
  // Return the users data
  //log(response.data)
  return response.data;
  
}

// Update cart - deletes products on specified date
/*
returns:


 "request": {
        "url": "http://localhost:3000/eshop/carts",
        "method": "PUT",
        "headers": [],
        "params": [],
        "body": {
          "mode": "json",
          "json": "{\n  \"subscriber_id\": 1208,\n  \"event_date\": \"13/07/2025\"\n}",
          "formUrlEncoded": [],
          "multipartForm": [],
          "file": []


*/
export const updateCart = async (start: string, end:string, dates: string[], adress?: string) => {
  const token = getAuthTokenOptional();

  const formatDateToMDY = (dateStr: string) => {
    const formatted = new Date(dateStr).toLocaleDateString("cs").replaceAll(". ", "/");
    const [day, month, year] = formatted.split("/");
    return `${month}/${day}/${year}`;
  };

  const newDateStr = formatDateToMDY(start);
  const nnewDateStr = formatDateToMDY(end);


  const payload: Record<string, any> = {
    event_dates: {
      start: newDateStr,
      end: nnewDateStr
    },
    selected_dates: dates
  };

  if (adress) {
    payload.adress = adress;
  }

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts/updateCart`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data;
};


// Set item - pouziju taky pro update hodnoty
/*
returns:

[
  {
    "id": 16,
    "created_by": null,
    "edited": null,
    "person_id": 1014,
    "subscriber_id": 1010,
    "cart_active": true,
    "event_date": null,
    "delivery_time": null,
    "items": {
      "1. 8. 2025": [],
      "2. 8. 2025": [
        {
          "id": 101,
          "category": "sales",
          "amount": 30,
          "name": "Rajčatová salsa s pečenými paprikami 90 g",
          "code": null,
          "price_without_tax": 2100,
          "price_with_tax": 2352,
          "price_per_piece": 70,
          "max_sale": 0,
          "tax_rate": "12%"
        },
        {
          "id": 111,
          "category": "sales",
          "amount": 20,
          "name": "Mini tartaletka s mascarpone krémem a ovocem",
          "code": null,
          "price_without_tax": 1030,
          "price_with_tax": 1153.6,
          "price_per_piece": 51.5,
          "max_sale": 0,
          "tax_rate": "12%"
        }
      ],
      "3. 8. 2025": []
    },
    "time": {
      "from": "1/8/2025",
      "to": "3/8/2025"
    },
    "totals": {
      "total_amount": 50,
      "total_price_without_tax": 3130,
      "total_price_with_tax": 3505.6,
      "total_tax": 375.6
    }
  }
]
*/
export const setItem = async (Item: CartItem) => {
  const token = getAuthTokenOptional();

  // Assuming Item.date exists and is a Date object
  if(Item.category === "activities"){
    Item.category = "activity"
  }
  const formattedItem = {
    ...Item,
    date: new Date(Item.date).toLocaleDateString("cs")
  };

  /*
  log("=== DEBUG SETITEM ===");
  log("Original Item:", Item);
  log("Formatted Item:", formattedItem);
  log("Request payload:", { item: formattedItem });
  */

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts/setItem`,
    {
      item: formattedItem
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};



// Delete item - deletes specified item on specified date
/*
returns:
State of the cart - same as set items

*/

export const deleteItem = async (Item: CartDeleteItem) => {
  const token = getAuthTokenOptional();

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts/deleteItem`,
    {
      item: Item
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

// Update item - updates the date and time
/*
returns:
Cart state - same as insert
*/
export const updateItem = async (Item: CartItem, new_date: string, new_time: string) => {
  const token = getAuthTokenOptional();

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts/updateItem`,
    {
        item: Item,
        new_date: new_date,
        new_time: new_time
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};



// Move items -  move all the items from set date and time to new date and time
export const moveItems = async (old_date: string, old_time: string, new_date: string, new_time: string) => {
  const token = getAuthTokenOptional();

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts/moveItems`,
    {
      old_date: old_date,
      old_time: old_time,
      new_date: new_date,
      new_time: new_time
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};


// Send order
export const createOrder = async (
  payment_method: string,
  code: string,
  name: string,
  phone_number: string,
  floor: string,
  room: string,
  receiving_person: string,
  preferred_collection_time: string,
  note: string
) => {
  const token = getAuthTokenOptional();

  const response = await axios.post(
    `${BACKEND_URL}/eshop/carts/order`,
    {
      payment_method,
      code,
      name,
      phone_number,
      floor: floor ?? "",
      room: room ?? "",
      receiving_person,
      preferred_collection_time,
      note,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  sessionStorage.setItem("lastSavedTime", "");
  sessionStorage.removeItem("deliveryTime");

  return response.data;
};

// fetch-based version (kept for debugging)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createOrderFetch = async (
  payment_method: string,
  code: string,
  name: string,
  phone_number: string,
  floor: string,
  room: string,
  receiving_person: string,
  preferred_collection_time: string,
  note: string
) => {
  const token = getAuthTokenOptional();
  const url = `${BACKEND_URL}/eshop/carts/order`;
  const body = { payment_method, code, name, phone_number, floor: floor ?? "", room: room ?? "", receiving_person, preferred_collection_time, note };

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });

  const text = await response.text();
  if (!response.ok) throw new Error(`Order failed: ${response.status} — ${text}`);

  sessionStorage.setItem("lastSavedTime", "");
  sessionStorage.removeItem("deliveryTime");

  return text ? JSON.parse(text) : null;
};
